import { NavigateFunction } from 'react-router-dom';

export const navigateTo = (
  destination: string, navigate: NavigateFunction,
): void => navigate(destination);

export const navigateBack = (navigate: NavigateFunction): void => navigate(-1);

export const redirect = (url: string): void => {
  window.open(url, '_blank');
};
export const redirectToLogin = (navigate: NavigateFunction): void => navigate('/login');
